import {React, useState, useEffect } from "react";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import { FxmsData } from "../../fxms/datas/FxData";
import html2canvas from 'html2canvas';
import { PDFDocument } from 'pdf-lib';
import { TradeAnalysis } from "../components/FxTradeAnalysis";

/* 에너지거래->리포트*/
export const UI_6_3 = () => {
  const user = FxmsData.getUser();
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchYearOptions, setFetchYearOptions] = useState([]); 
  const [fetchMonthOptions, setFetchMonthOptions] = useState([]); 
  const [selected, setSelected] = useState({
    complexInloNo: "",
    complexName: "",
    datePeriod: "",
    dateYear: "",
    dateMonth: ""
  });
  const [fetchData, setFetchData] = useState([]);
  const [fetchData2, setFetchData2] = useState([]);
  const [showData, setShowData] = useState(false);
  const [displayDate, setDisplayDate] = useState({
    year: "",
    month: "",
    period: ""
  });

  useEffect(() => {
    console.log("*** UI_6_3 ***");
    getComplexInloData();
    selectMonthOptions();
    selectYearOptions();
  }, [user]);

  useEffect(() => {
    setSelected(prev => ({
      ...prev,
      dateYear: "",
      dateMonth: ""
    }));
  }, [selected.datePeriod]);


  useEffect(()=> {
    if (selected.complexInloNo == "") return;

    const selectedComplex = fetchComplexInlo.find(item => item.inloNo == selected.complexInloNo);
    setSelected(prev => ({
      ...prev,
      complexName: selectedComplex.inloName
    }));
  },[selected.complexInloNo]);
  
  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      setFetchComplexInlo(res.data);             
      console.log("complex List >> ", res.data);       
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  // 연도 옵션 생성 (현재 월이 1월이면 이전연도까지, 2월 이후면 현재연도 포함)
  const selectYearOptions = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // 0-11이므로 1을 더함
    const startYear = currentMonth === 1 ? currentYear - 1 : currentYear;
    
    for (let i = 0; i < 5; i++) {
      years.push(startYear - i);
    }
    setFetchYearOptions(years);
  };

  // 월 옵션 생성 함수 추가
  const selectMonthOptions = () => {
    const options = [];
    for (let month = 1; month <= 12; month++) {
      const formattedMonth = month.toString().padStart(2, '0');
      options.push(`${formattedMonth}`);
    }
    setFetchMonthOptions(options);
  };

  const submitBtnClick = async () => {

    if (selected == null) return;

    if ( user.ugrpNo === 1020 && selected.complexInloNo == "") {
      FxWindow.alert("산업단지를 선택해주세요.", true);
      return;
    }
    if (selected.datePeriod == "") {
      FxWindow.alert("조회기간을 선택해주세요.", true);
      return;
    }
    if (selected.dateYear == "") {
      FxWindow.alert("년도를 선택해주세요.", true);
      return;
    }
    if (selected.datePeriod == "MONTH" && selected.dateMonth == "") {
      FxWindow.alert("월을 선택해주세요.", true);
      return;
    }

    // 조회 시점의 날짜 정보 저장
    setDisplayDate({
      year: selected.dateYear,
      month: selected.dateMonth,
      period: selected.datePeriod
    });
    const param = {
      complexInloNo: selected.complexInloNo,
      datePeriod: selected.datePeriod,
      dateYear: selected.dateYear,
      dateMonth: selected.dateMonth,
      sinkSource: "SINK"
    }
    console.log("UI_6_3 param........", param);
    try {
      const uri = "vup/select_6_3";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_6_3 res........", res.data);
      setFetchData(res.data);
      setShowData(true);
      console.log("UI_6_3 fetchData........", fetchData);
    } catch (e) {
      console.log("UI_6_3 fetchData error", e);
    }

    const param2 = {
      complexInloNo: selected.complexInloNo,
      datePeriod: selected.datePeriod,
      dateYear: selected.dateYear,
      dateMonth: selected.dateMonth,
      sinkSource: "SOURCE"
    }
    console.log("UI_6_3 param2........", param2);
    try {
      const uri = "vup/select_6_3";
      const res = await FxmsData.GET(uri, param2);
      console.log("UI_6_3 res........", res.data);
      setFetchData2(res.data);
      setShowData(true);
      console.log("UI_6_3 fetchData2........", fetchData2);
    } catch (e) {
      console.log("UI_6_3 fetchData2 error", e);
    }
  }

  const handleSelectData = (event) => {
    const { id, value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })    
  }

  const handlePdfDownload = () => {
    // 숨겨진 컨테이너 생성
    const hiddenContainer = document.createElement('div');
    hiddenContainer.style.cssText = `
      position: absolute;
      left: -9999px;
      top: -9999px;
      width: 2480px;
      height: 1748px;
      background: #2A2A2A;
      display: none;
    `;
    document.body.appendChild(hiddenContainer);
    
    const element = document.querySelector('.vupReport');
    const clone = element.cloneNode(true);
    
    // 스타일 적용
    clone.style.cssText = `
      background: #2A2A2A;
      color: #fff;
      display: flex;
      justify-content: space-between;
      gap: 20px;
      padding: 30px;
      box-sizing: border-box;
      width: 2480px;
      height: 1748px;
      margin: 0; // 마진 제거
    `;
  
    // 테이블 스타일 직접 적용
    clone.querySelectorAll('table').forEach(table => {
      table.style.cssText = `
        width: 100%;
        border-collapse: collapse;
        background: #2A2A2A;
      `;
    });
  
    clone.querySelectorAll('th').forEach(th => {
      th.style.cssText = `
        background: #1E1E1E;
        color: #fff;
        padding: 12px 8px;
        border: 1px solid #444;
        font-size: 14px;
        font-weight: normal;
      `;
    });
  
    clone.querySelectorAll('td').forEach(td => {
      td.style.cssText = `
        padding: 10px 8px;
        border: 1px solid #444;
        color: #fff;
        font-size: 14px;
        text-align: center;
      `;
    });
  
    hiddenContainer.appendChild(clone);
  
    const complexName = user.ugrpNo === 1020 ? selected.complexName : fetchComplexInlo[0].inloName;

    const pdfName = selected.datePeriod === "MONTH" ? 
      `${complexName} ${displayDate.year}년 ${displayDate.month}월 월간 에너지거래_리포트.pdf` : 
      `${complexName} ${displayDate.year}년 연간 에너지거래_리포트.pdf`;
  
    const canvasHeight = user.ugrpNo === 1024 && selected.datePeriod === "MONTH" ? 3200 : 1753;
    // A4 landscape in pt
    const A4_W = 841.89;
    const A4_H = 595.28;

    requestAnimationFrame(async () => {
      try {
        hiddenContainer.style.display = 'block';
        const canvas = await html2canvas(clone, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#2A2A2A',
          logging: false,
          width: 2480,
          height: canvasHeight,
          windowWidth: 2480,
          windowHeight: canvasHeight,
        });

        const imgData = canvas.toDataURL('image/png');
        const pdfDoc = await PDFDocument.create();
        const page = pdfDoc.addPage([A4_W, A4_H]);
        const pngImage = await pdfDoc.embedPng(imgData);
        page.drawImage(pngImage, { x: 0, y: 0, width: A4_W, height: A4_H });

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = pdfName;
        a.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error('PDF 생성 중 오류:', err);
      } finally {
        document.body.removeChild(hiddenContainer);
      }
    });
  };

  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          {user.ugrpNo === 1020 &&
            <>
              <label className="FxLabelSearch"></label>
              <select className="FxSelectSearch" name="complexInloNo" onChange={handleSelectData} value={selected.complexInloNo}>
                <option value="">산업단지명</option>
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
              </select>
            </>
          }
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="datePeriod" onChange={handleSelectData} value={selected.datePeriod}>
            <option value="">조회기간</option>
            <option value="MONTH">월간</option>
            <option value="YEAR">연간</option>
          </select>
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="dateYear" onChange={handleSelectData} value={selected.dateYear}>
            <option value="">년도</option>
            {fetchYearOptions.map((item) => (
              <option key={item} value={item} name="dateYear">
                {item}년
              </option>
            ))}
          </select>
          {selected.datePeriod === "MONTH" &&
            <select className="FxSelectSearch" name="dateMonth" onChange={handleSelectData} value={selected.dateMonth}>
              <option value="">월</option>
              {fetchMonthOptions.map((item) => (
                <option key={item} value={item} name="dateMonth">
                  {item}월
                </option>
              ))}
            </select>
          }
        </div>
        <div className="FxFilterRight">
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
      {showData && 
      <div className="FxCrudDataGrid">
        <div className="vupReportTitle">
          {displayDate.period === "MONTH" &&<strong>{displayDate.year}년 {displayDate.month}월 에너지 거래 월간 리포트</strong>}
          {displayDate.period === "YEAR" &&<strong>{displayDate.year}년 에너지 거래 연간 리포트</strong>}
          <button onClick={handlePdfDownload}>PDF</button >
        </div>
        <div className="vupReport">
          {/* 매수거래 리포트 */}
          <TradeAnalysis 
            type="SINK"
            period={selected.datePeriod}
            data={fetchData}
            userType={user.ugrpNo}
          />
          {/* 매도거래 리포트 */}
          <TradeAnalysis 
            type="SOURCE"
            period={selected.datePeriod}
            data={fetchData2}
            userType={user.ugrpNo}
          />
        </div>
      </div>
      }
    </div>
    </>
  )
}